export const PROJECT_STATUS_COLORS = [
    "#789CB0", "#FF6A38", "#F5A400", "#417FFA", "#48C166",
    "#718FFF", "#8466FF", "#EC5FFF", "#45BEFF", "#FFC145",
]

export const FIXED_PROJECT_STATUS_KEYS = ['backlog', 'in_progress', 'complete']

export const FIXED_PROJECT_STATUS_COLORS: Record<string, string> = {
    backlog: PROJECT_STATUS_COLORS[0],
    in_progress: PROJECT_STATUS_COLORS[2],
    complete: PROJECT_STATUS_COLORS[4],
}

export const getProjectStatusColor = (key: string, color: string) => {
    return FIXED_PROJECT_STATUS_COLORS[key] || color
}

export interface ProjectTaskStatusItem {
    id?: string | number
    key: string
    name?: string
    title?: string
    color: string
    position?: number
    is_mandatory?: boolean
}

export interface ProjectTaskStatusPayload {
    key: string
    name: string
    color: string
    position: number
}

export interface ProjectBoardStatus {
    title: string
    key: string
    color: string
}

export const sortProjectStatuses = <T extends { position?: number }>(statuses: T[]) => {
    return [...statuses].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
}

export const toProjectStatusPayload = (statuses: ProjectTaskStatusItem[]): ProjectTaskStatusPayload[] => {
    return statuses.map((status, index) => ({
        key: status.key,
        name: status.name || status.title || '',
        color: getProjectStatusColor(status.key, status.color),
        position: index,
    }))
}

export const toProjectBoardStatuses = (statuses: ProjectTaskStatusItem[]): ProjectBoardStatus[] => {
    return statuses.map((status) => ({
        title: status.name || status.title || '',
        key: status.key,
        color: getProjectStatusColor(status.key, status.color),
    }))
}
